export const VALIDATION_MESSAGES = {
    requiredField: "Los campos con * son obligatorios",
    emptyDetail: "Debes agregar por lo menos un detalle",
    oneSuppliersAtLeast: "Debes seleccionar un proveedor por lo menos",
}